import '../node_modules/bootstrap/scss/bootstrap.scss' 

import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode'

// import logo from './logo.svg';
import bg from './img/bg.png';
import productos from './img/productos.gif'
import digital from './img/digital.gif'
import './App.css';

import Viewer, { Worker } from '@phuocng/react-pdf-viewer';

import CartillaVivienda from './fichas/CARTILLASOL.VIVIENDA.pdf'
import CartillaTuneles from './fichas/CARTILLASOL.TUNELES.pdf'
import CartillaPuertos from './fichas/CARTILLASOL.PUERTOS.pdf'
import CartillaPuentes from './fichas/CARTILLASOL.PUENTES.pdf'
import CartillaPavimentos from './fichas/CARTILLASOL.PAVIMENTOS.pdf'
import CartillaEdificacion from './fichas/CARTILLASOL.EDIFICACION.pdf'
import CartillaArquitectonicos from './fichas/CARTILLASOL.ARQUITECTONICOS.pdf'

import Breadcrumbs from './Breadcrumbs'
import Nav from './Nav'

import { Link } from "react-router-dom";

function App() {

  const DrawCanvasLink = (file) => {
    return (
      <a href={'https://expo-melon.s3.amazonaws.com/fichas/'+file.url} target="_blank">
        <canvas id="qr-canvas" width="300" height="300"></canvas>
      </a>
      )
  }

  let [showPDFModal, setShowPDFModal] = useState(false);
  let [pdfFile, setPdfFile] = useState();
  let [pdfFileLocal, setPdfFileLocal] = useState('');
  let [pdfFileUrl, setPdfFileUrl] = useState('');

  useEffect(() => {

    setTimeout(() => {
      let pdfString = 'https://expo-melon.s3.amazonaws.com/fichas/'+pdfFile;
      if (document.getElementById('qr-canvas')) {
        QRCode.toCanvas(document.getElementById('qr-canvas'), pdfString, {width: 300}, function (error) {
          if (error) console.error(error)
        });      
      }
    }, 1000);

  }, [showPDFModal])

  // useEffect(() => {

  //   setPdfFileUrl('https://expo.melon.cl/fichas/'+pdfFile);
  //   setPdfFileLocal('./fichas/'+pdfFile);

  //   console.dir(pdfFile);
  //   console.dir(pdfFileUrl);
  //   console.dir(pdfFileLocal);


  // }, [pdfFile])


  return (
    <div className="App container-fluid g-0 fullvh">

    {showPDFModal &&

      <div className="modal-container d-flex flex-column">
        <button style={{position: 'absolute', top: '0vh', left: '93.5vw', zIndex: 9}} className="nav-button" onClick={() => setShowPDFModal(false)}><i className="fa-sharp fa-solid fa-close" data-fa-mask="fa-solid fa-comment"></i></button>
        <div className="modal-content d-flex flex-1 align-items-center justify-center">
          <div className="row">
            <div className="col">
              <div className="bg-white p-3">
                <Worker workerUrl="/pdf.worker.min.js">
                    <div style={{ height: '100vh', width: '60vw' }}>
                        <Viewer fileUrl={pdfFileLocal} />
                    </div>
                </Worker>
              </div>
            </div>
              <div className="col">
                <div className="bg-white p-3">
                  <p>Escanea o presiona para descargar</p>
                  {navigator.userAgent.indexOf('Electron') >= 0 &&
                    <canvas id="qr-canvas" width="300" height="300"></canvas>
                  }
                  {navigator.userAgent.indexOf('Electron') == -1 &&
                    <DrawCanvasLink url={pdfFile} />
                  }
                </div>
              </div>            
          </div>
        </div>
      </div>

    }       

      <div className="row g-0">

        <img src={productos} className="bg" />

        <div className="row g-0 fullvh">

          <div className="col-2">
            <Nav />
          </div>

          <div className=" col d-flex">

            <div className="row g-0 d-flex flex-1 flex-column justify-center">

              <div className="col d-flex flex-column justify-center">

                <div className="row">
                  
                  <div className="d-flex">
                    <h3 className="text-white pb-5 t-76 title-shade">Resumen de Soluciones Constructivas</h3>    
                  </div>

                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center ">

                      
                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.ARQUITECTONICOS.pdf')
                        setPdfFileLocal(CartillaArquitectonicos)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Arquitectónicos <span className="chevron">></span></p>
                      </div>

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.EDIFICACION.pdf')
                        setPdfFileLocal(CartillaEdificacion)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Edificación <span className="chevron">></span></p>
                      </div>  

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.PAVIMENTOS.pdf')
                        setPdfFileLocal(CartillaPavimentos)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Pavimentos <span className="chevron">></span></p>
                      </div>

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.PUENTES.pdf')
                        setPdfFileLocal(CartillaPuentes)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Puentes <span className="chevron">></span></p>
                      </div>
                      
                    </div>                    

                  </div>


                  <div className="row pt-3 pb-3">

                    <div className="col d-flex flex-row align-items-center">

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.PUERTOS.pdf')
                        setPdfFileLocal(CartillaPuertos)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Puertos <span className="chevron">></span></p>
                      </div>

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.TUNELES.pdf')
                        setPdfFileLocal(CartillaTuneles)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Túneles <span className="chevron">></span></p>
                      </div> 

                      <div onClick={() => {
                        setPdfFile('CARTILLASOL.VIVIENDA.pdf')
                        setPdfFileLocal(CartillaVivienda)
                        setShowPDFModal(true)
                      }} className="product-block-resumen d-flex flex-column">
                        <p className="product-block-resumen-text text-center">Vivienda <span className="chevron">></span></p>
                      </div>                                            

                      
                    </div>                    

                  </div>                   


                </div>
                
              </div>
              
            </div>
            
          </div>          
          
        </div>

      </div>

    </div>
  );
}

export default App;
